<template>
    <div>
        <b-button class="ml-2" size="sm" variant="primary" @click="openModal">
            <i :class="['icon', 'inticon-edit']"/>
            {{ buttonText }}
        </b-button>
        <b-modal v-model="show" hide-footer title="Aktualisierung der Daten anfragen" @hide="reset">
            <div class="info-card editMode loading-content-container">
                <div v-if="isLoading" class="loading-overlay d-flex justify-content-center pt-5">
                    <csp-loading-indicator/>
                </div>
                <b-form v-else @submit.prevent="submit">
                    <csp-form-group-textarea
                        class="info-card-element"
                        :form="form"
                        :override-label="fieldLabel"
                        property="retroactiveChangesNote"/>
                    <div class="text-right">
                        <button class="btn btn-primary" :disabled="isLoading" type="submit">
                            An Verantwortlichen senden
                        </button>
                    </div>
                </b-form>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Form from '@form/Form';
    import Container from '@services/Container';
    const container = Container.getInstance()
    const recordRepository = container.getDesktopRecordRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        props: {
            recordId: {type: [Number], required: true},
            title: {type: String, required: true},
            buttonText: {type: String, default: null},
        },
        data() {
            return {
                show: false,
                form: new Form({retroactiveChangesNote: ''}),
                isLoading: false,
            };
        },
        computed: {
            fieldLabel() {
                if (this.title) {
                    return this.$t('form field retroactiveChangesNote') + ' (im Bereich ' + this.title + ')';
                }

                return this.$t('form field retroactiveChangesNote')
            },
        },
        methods: {
            openModal() {
                this.show = true;
            },
            reset() {
                this.form.reset();
            },
            submit() {
                let {retroactiveChangesNote} = this.form.getData();

                this.isLoading = true;

                recordRepository.addRetroactiveChangesNote(
                    this.recordId,
                    {
                        data: {
                            attributes: {
                                'retroactiveChangesNote': retroactiveChangesNote,
                                'context': this.title,
                            },
                        },
                    }
                ).then(
                    () => {
                        this.show = false;
                        this.isLoading = false;
                        flashMessenger.addSuccess(this.$t('note added successfully'));
                    },
                    (error) => {
                        this.isLoading = false;
                        this.form.setValidationErrors(error);
                    }
                );
            },
        },
    };
</script>
